import React from "react";
import styles from '../styles/eventRules.module.scss'
import { useAssetImage } from "@/platforms/utils";
import SpriteContainer from "@/wmCompoments/spriteContainer";

interface eventRulesProps {
  rules: any
}

const EventRules: React.FC<eventRulesProps>  = (props) => {
  const { rules } = props

  return(
    <div className={styles.eventRules}>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: rules }} />
    </div>  
  )
}

export default EventRules